import { createActions } from 'redux-actions';

export const { loadCustomFilters, loadedCustomFilters, errorCustomFilters } = createActions(
  'LOAD_CUSTOM_FILTERS',
  'LOADED_CUSTOM_FILTERS',
  'ERROR_CUSTOM_FILTERS',
);
